import { ExperienceTemplate } from 'experience-template-renderer-react';

import { CustomerNotificationLocation } from '@shared-ui/customer-notifications';

export const carouselSearchTemplate: ExperienceTemplate = {
  id: 'carousel-search-view-large',
  version: '1',
  components: [
    {
      metadata: {
        id: 'LayoutFlex',
      },
      type: 'UitkComponent',
      config: {
        type: 'UitkLayoutFlex',
      },
      children: [
        {
          metadata: {
            id: 'LayoutFlexItemMain',
          },
          type: 'UitkComponent',
          config: {
            type: 'UitkLayoutFlexItem',
            grow: 1,
          },
          children: [
            {
              metadata: {
                id: 'toolbarRegion',
              },
              type: 'ToolbarRegion',
              children: [
                {
                  metadata: {
                    id: 'playback',
                  },
                  type: 'Playback',
                },
                {
                  metadata: {
                    id: 'resultsHeader',
                  },
                  type: 'ResultsHeader',
                },
              ],
            },
            {
              metadata: {
                id: 'mainRegion',
              },
              type: 'MainRegion',
              children: [
                {
                  metadata: {
                    id: 'mitHeader',
                  },
                  type: 'MitHeader',
                },
                {
                  metadata: {
                    id: 'customerNotificationsAfterHeader',
                  },
                  type: 'CustomerNotificationTemplateComponent',
                  config: {
                    location: CustomerNotificationLocation.AFTER_HEADER,
                  },
                },
                {
                  metadata: {
                    id: 'carouselSearch',
                  },
                  type: 'CarouselSearchWrapper',
                },
                {
                  metadata: {
                    id: 'customerNotificationsFooter',
                  },
                  type: 'CustomerNotificationTemplateComponent',
                  config: {
                    location: CustomerNotificationLocation.FOOTER,
                  },
                },
                {
                  metadata: {
                    id: 'delayedSortAndFilterFetchExperiment',
                  },
                  type: 'DelayedSortAndFilterFetchExperiment',
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
